import React from "react"
import styled from "styled-components"
import Link from "next/link"

import { cut, buildSlug } from "~/utilities/string"

import { CATEGORIES_URL } from "~/components/faq/constants"

const ArticleContainer = styled.div`
  text-decoration: none;
  color: black;
  display: flex;
  flex-direction: row;
  ${props => props.theme.media.mobile`
    flex-direction: column;
  `};
  flex-wrap: wrap;
  flex-grow: 1;
  margin: 0 0 4em 0;
`

const Image = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 100px;
  overflow: hidden;
  ${props => props.theme.media.mobile`
    width: 100%;
  `};
  img {
    max-width: 100px;
    max-height: 100px;
  }
`

const TextContainer = styled.div`
  flex: 1;
  margin: 0 0 0 10px;
  ${props => props.theme.media.mobile`
    margin: 0;
  `};
  a {
    color: ${props => props.theme.colors.primary};
    cursor: pointer;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  h3 {
    a {
      color: black;
    }
    text-decoration: none;
    margin: 0 0 10px 0;
  }
  p {
    font-family: ${props => props.theme.fonts.avenirNextRegular};
    margin: 10px 0 0 0;
    padding: 0;
    max-width: 500px;
    font-size: 0.813em;
  }
`

const ArticleList = ({ list }) => {
  return list.map(article => {
    const categorySlug = CATEGORIES_URL[article.type[0]]
    const slug = buildSlug(article.title)
    const linkHref = "/knowledge-base/[category]/[...slug]"
    const linkAs = `/knowledge-base/${categorySlug}/article/${slug}`
    return (
      <ArticleContainer key={slug}>
        <Image>
          {article.icon && <img src={article.icon} alt={article.title} />}
        </Image>
        <TextContainer>
          <h3>
            <Link href={linkHref} as={linkAs} passHref>
              <a>{article.title}</a>
            </Link>
          </h3>
          <p>
            {cut(article.content, 120, "...")}
            &nbsp;
            <Link href={linkHref} as={linkAs} passHref>
              <a>Learn more</a>
            </Link>
          </p>
        </TextContainer>
      </ArticleContainer>
    )
  })
}

export default ArticleList
